export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-2960x1050-a624e2c444e53279a5131844443778a6.jpg";